/*
 * Product gallery.
 *
 * Thumbnails are anchors to the full image, so without JavaScript clicking one
 * opens that image rather than doing nothing. This intercepts the click and
 * swaps the frame instead.
 */
class CalmlyteGallery extends HTMLElement {
  connectedCallback() {
    this.frame = this.querySelector('[data-gallery-frame]');
    this.figure = this.querySelector('.cl-gallery__frame');
    this.thumbs = Array.from(this.querySelectorAll('[data-gallery-pick]'));

    if (!this.frame || this.thumbs.length < 2) return;

    for (const thumb of this.thumbs) {
      thumb.addEventListener('click', event => {
        event.preventDefault();
        this.show(thumb);
      });
    }
  }

  show(thumb) {
    const { full, set, alt, fit, ratio, bg } = thumb.dataset;

    /* srcset is cleared before src is set. Left in place it keeps describing
       the previous image, and the browser is entitled to keep showing that one. */
    this.frame.removeAttribute('srcset');
    if (set) this.frame.setAttribute('srcset', set);
    if (full) this.frame.setAttribute('src', full);

    this.frame.setAttribute('alt', alt || '');
    this.frame.style.objectFit = fit || 'contain';

    /* The frame's proportions and its letterbox colour belong to the image
       being shown, not to the gallery, so they move with it. Written to the
       figure rather than the img: aspect-ratio has to size the box the image
       sits in, and the background is behind the image, not on it. */
    if (this.figure) {
      this.figure.style.setProperty('--cl-frame-ratio', ratio || '4 / 3');
      /* Removed rather than set to a colour, so the CSS fallback comes back and
         one image carrying a colour cannot leave it behind on the next. */
      if (bg) this.figure.style.setProperty('--cl-frame-bg', bg);
      else this.figure.style.removeProperty('--cl-frame-bg');
    }

    for (const other of this.thumbs) {
      other.classList.toggle('is-active', other === thumb);
    }
  }
}

if (!customElements.get('calmlyte-gallery')) {
  customElements.define('calmlyte-gallery', CalmlyteGallery);
}
